import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectPersonValue } from 'services/people/selectors';

import { AppState } from 'services/types';

interface IOwnProps {
    personId: number;
}

interface IStateProps {
    email?: string;
}

interface IDispatchProps {}

export interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class PersonEmail extends React.PureComponent<IProps> {
    render() {
        const { email } = this.props;
        if (!email) return null;
        return email;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    IOwnProps,
    IStateProps
>({
    email: makeSelectPersonValue('email')
});

export default connect(mapStateToProps)(PersonEmail);
